import notify from '@/migration/notification';

type Type = 'success' | 'error' | 'info';

export const show = (type: Type, message: string) => {
  notify(message, type);
};
